import { useCallback } from 'react';
import * as React from 'react';
import { Button, Form, FormItem, Input, Layout, Password, Title } from '@/components/atoms';
import { useSelector } from 'react-redux';
import { RootState } from '@/rootReducer';
import api from '@/api';
import { API_AUTH_LOGIN } from '@/constants/constant';

export type PasswordCheckerProps = {
  title: React.ReactNode;
  onPerformed: (allow: boolean) => void;
};

const PasswordChecker = ({ title, onPerformed }: PasswordCheckerProps) => {
  const { user } = useSelector((state: RootState) => state.account);

  const login = useCallback(
    (password) => {
      api
        .post(API_AUTH_LOGIN, 'pauth.PbLoginRequest', {
          email: user.email,
          password,
        })
        .then(() => {
          onPerformed(true);
        })
        .catch(() => {
          onPerformed(false);
        });
    },
    [onPerformed, user],
  );

  return (
    <Layout className="password-checker w-1/3 mx-auto">
      <Title>{title}</Title>
      <Form onFinish={({ password }) => login(password)}>
        <FormItem name="password">
          <Password />
        </FormItem>
        <Button className="w-full" htmlType="submit">
          확인
        </Button>
      </Form>
    </Layout>
  );
};

PasswordChecker.defaultProps = {
  title: '계정 확인을 위해 암호를 입력해주세요',
};

export default PasswordChecker;
